module.exports = __webpack_public_path__ + "static/media/avatar.e64b8ef6.svg";